import { render, staticRenderFns } from "./SupplierHistory.vue?vue&type=template&id=b9daf1f2"
import script from "./SupplierHistory.vue?vue&type=script&lang=js"
export * from "./SupplierHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports